<template>
  <div
    class="ti-usabilla-wrapper"
    v-if="usabillaConfig && usabillaConfig.applicationId"
  >
    <div class="ti-usabilla-wrapper__content">
      <h2>{{ $t('i18n.confirmation.usabilla.feedback.headline') }}</h2>
      <div class="ti-usabilla" :ub-in-page="usabillaConfig.applicationId"></div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { UsabillaConfig } from '@tradein/store';
import { onMounted } from 'vue';
import setup from '../../composables/setup';

interface Props {
  usabillaConfig: UsabillaConfig;
}

const { $parseSrc } = setup();
const props = defineProps<Props>();

onMounted(() => {
  if (props.usabillaConfig && props.usabillaConfig.jsUrl) {
    loadScript();
  }
});

const loadScript = (): Promise<string> => {
  const tradeinAppElement = document.getElementsByTagName('tradein-app')[0];
  return new Promise((resolve, reject) => {
    if (!props.usabillaConfig.jsUrl || !props.usabillaConfig.applicationId) {
      reject();
    }

    const element = document.createElement('script');
    element.setAttribute('src', $parseSrc(props.usabillaConfig.jsUrl));

    if (tradeinAppElement?.shadowRoot) {
      tradeinAppElement?.shadowRoot.appendChild(element);
    } else {
      document.head.appendChild(element);
    }
    element.onload = () => {
      resolve(props.usabillaConfig.jsUrl);
    };
    element.onerror = () => {
      reject();
    };
  });
};
</script>
<style lang="scss">
.ti-usabilla-wrapper {
  @include ti-grid-column(12);
  @include wb-spacing('margin-top', 's');

  &__content {
    @include wb-spacing('padding', 's m');
    background: var(--wb-white);
    box-shadow:
      0 0 2px 0 rgba(0, 0, 0, 0.1),
      0 2px 4px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;

    h2 {
      @include wb-type-heading-s;
      @include wb-spacing('margin-bottom', 'xxs');
      text-align: center;
    }

    .ti-usabilla {
      display: block;
      position: relative;
      width: 100%;
    }
  }
}
</style>
